import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    main: {
      '& .MuiPaper-root': {
        width: 615,
      },
      '& .MuiDialogTitle-root': {
        textAlign: 'center',

        '& h3': {
          fontSize: '2.4rem',
        },
      },
      '& .MuiDialogContent-root, .MuiDialogActions-root': {
        backgroundColor: '#F9F9FB',
      },

      '& .MuiDialogContent-root': {
        '& .MuiDialogContentText-root > .MuiTypography-body1': {
          textAlign: 'center',
          padding: '1.5rem 0',
        },
      },
    },
    info: {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
      padding: '1rem',
      borderRadius: 4,
    },
    infoRow: {
      display: 'flex',
      flexDirection: 'row',
      gap: '1rem',
      textAlign: 'right',
      '& > .MuiTypography-subtitle1': {
        flex: 1,
        textAlign: 'start',
        whiteSpace: 'nowrap',
      },
    },
  }),
)
